export const styles = {
  wrap: {
    minHeight: 'calc(100vh - 56px)',
    paddingBottom: '10px',
    display: 'grid',
  },
};
